import { get } from './client';

const API_BASE_URL =
  process.env.REACT_APP_CHECKIN_API_URL ?? 'https://dev-api.checkin.degencoinflip.com/v1';

export const getKycProfiles = async (Authorization = '') => {
  try {
    const response = await get(`${API_BASE_URL}/kyc-profiles`, { Authorization });
    console.log(response);
    return response.payload.profiles;
  } catch (error) {
    console.error('Error fetching KYC profiles:', error);
    throw error;
  }
};
